<template>
  <div name="navigation" :class="{'navigation': true, 'fixed': isScrolled}">
    <div class="header">
      <a href="https://soldoc.co.kr/" class="logo-area">
        <img class="logo" src="../../assets/basic/pc/logo.png" alt="soldoc+"/>
        <img class="logo-blue" src="../../assets/pc_barocare/logo_blue.png"
             alt="soldoc+"/>
      </a>
      <div class="menu">
        <ul class="link-list">
          <li><a href="#hero" class="link-item">솔닥</a></li>
          <li>
            <a href="https://concierge.soldoc.co.kr/barocarenew?utm_source=soldoc_web&utm_medium=NB&utm_campaign=dm_0501&utm_content=dm_0501&utm_term=dm_0501" class="link-item" target="_blank">솔닥 컨시어지</a>
          </li>
          <li><a href="https://soldoc.co.kr/barocare/" class="link-item"
                 target="_blank" title="새창으로 열림">바로돌봄</a></li>
          <li><a href="https://soldoc.co.kr/partners/" class="link-item"
                 target="_blank" title="새창으로 열림">솔닥파트너스</a></li>
          <li><a
            href="https://play.google.com/store/apps/details?id=com.soldocapp"
            class="link-item btn-download" target="_blank" title="새창으로 열림"><img
            class="ico" src="../../assets/renew_pc/ico-google-play.png"
            alt="google play"/><span>앱 다운로드</span></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data() {
    return {
      isScrolled: false
    };
  },
  mounted: function () {
    $('html').animate({
      scrollTop: 0
    }, 100);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    goBarosoldoc: function () {
      var element = document.getElementById("hero");
      if (element) {
        var rect = element.getBoundingClientRect();
        var offsetTop = rect.top + window.scrollY;
        window.scrollTo({
          // top: offsetTop - 160,
          top: offsetTop,
          behavior: "smooth"
        });
      }
    },
    handleScroll() {
      var mainHeight = window.innerHeight - 200;
      var elementHeight = window.innerHeight * 2;
      if (window.scrollY >= 0 && window.scrollY <= mainHeight) {
        document.querySelector('.navigation').style.position = 'fixed';
      } else if (window.scrollY >= mainHeight && window.scrollY < elementHeight) {
        document.querySelector('.navigation').style.position = 'static';
      } else {
        document.querySelector('.navigation').style.position = 'fixed';
      }
      if (window.scrollY >= elementHeight) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
  }
}
</script>

<style scoped>
.navigation {
  position: absolute;
  top: 0;
  width: 100%;
  height: 105px;
  /* background: #555; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 100;
}

.navigation.fadeout {
  animation: fadeOutUp 1s;
}

.navigation.fixed {
  position: fixed;
  height: 80px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  animation: fadeInUp 1s;
}

.navigation.fixed .header {
  margin-top: 0;
}

.navigation.fixed .logo {
  display: none;
}

.navigation.fixed .logo-blue {
  display: block;
}

.navigation.fixed .link-item {
  color: #1A1A1A;
}

.navigation.fixed .btn-download {
  background: #fff;
  border: 1px solid #0082EC;
  color: #0082EC;
}

.navigation.fixed .btn-download:hover {
  background: #0082EC;
  color: #fff;
}

.header {
  position: fixed;
  position: sticky;
  top: 0;
  display: flex;
  width: 100%;
  min-width: 960px;
  max-width: 1320px;
  padding: 0 1px 0 20px;
  height: 80px;
  margin-top: 23px;
  justify-content: space-between;
  align-items: center;
}

.logo-area {
  width: 106px;
  margin-top: -5px;
}

.logo-area img {
  width: 100%;
}

.logo-blue {
  display: none;
}

.menu {
  padding-left: 100px;
}

.link-list {
  display: flex;
  align-items: center;
  /* width: 618px; */
  height: 80px;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.link-list li + li {
  margin-left: 10px;
}

.link-list .link-item {
  padding: 20px 17px;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  cursor: pointer;
  border: none;
  background: transparent;
  text-decoration: none;
  color: #fff;
}

.link-item.btn-download {
  width: 158px;
  min-height: 48px;
  margin-left: 60px;
  padding: 7px 27px;
  border-radius: 4px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.10);
  font-size: 16px;
}

.link-item.btn-download .ico + span {
  margin-left: 10px;
}

.btn-area {
  margin-top: 10px;
}

.btn-download {
  display: inline-flex;
  min-height: 50px;
  padding: 7px 29px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.10);
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 400;
  line-height: 1.3;
  cursor: pointer;
  text-decoration: none;
}

.btn-download:hover {
  background: #FFF;
  color: #0082EC;
  font-weight: 600;
  text-decoration: none;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, -50%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0%, 0);
  }
}

@keyframes fadeOutUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 0%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, -50%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_main/Navigation.vue